module.exports = {
	"articleTitle1": "Young Michigan team finishes seventh at Big Ten Championships ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Logan an American Restaurant",
	"articleLink1": "https://www.michigandaily.com/section/football/young-michigan-team-finishes-seventh-big-ten-championships",
	"articleLink2": "https://www.michigandaily.com/section/arts/restaurant-week-guide",
	"articleSnippet1": "Mar 5, 2017 ... Redshirt freshman Logan Massa dominates in a match against Lehigh's Mitch ... \nAmine bests another All-American in dual meet against Iowa.",
	"articleSnippet2": "Jan 12, 2016 ... Looking at the Ann Arbor Restaurant Week website, it doesn't really seem like ... \nCarlyle Grill, Carson's American Bistro, Guy Hollerin's, Mediterrano, Metzger's ... \nThe same goes for Logan, practically next door to The Earle.",
	"foodRecommendations": [],
	"articleTitle2": "The Michigan Daily's guide to Restaurant Week ",
	"address": "115 W Washington St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.280247,
		"lng": -83.749347
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/logan.json
// module id = 909
// module chunks = 0